import React from "react";

import DesktopHeader from "./baseHeader/desktop";
import MobileHeader from "./baseHeader/mobile/BaseTopHeader";
import { CATEGORY_TYPE_COMMERCIAL_CATEGORY, CATEGORY_TYPE_PRODUCT_TYPE, PRODUCTS_ORDER } from "lib/constants";

function getOrderedProductTypes(categories) {
  return categories
    .filter((cat) => cat.type === CATEGORY_TYPE_PRODUCT_TYPE)
    .sort((p, next) =>
      PRODUCTS_ORDER.findIndex((m) => m === p.slug) < 0 ||
      PRODUCTS_ORDER.findIndex((m) => m === p.slug) > PRODUCTS_ORDER.findIndex((m) => m === next.slug)
        ? 1
        : -1
    );
}

function Header({ categories }) {
  const productTypes = getOrderedProductTypes(categories);
  const commercialCategories = categories.filter((cat) => cat.type === CATEGORY_TYPE_COMMERCIAL_CATEGORY);

  return (
    <>
      <MobileHeader productTypes={productTypes} commercialCategories={commercialCategories} />
      <DesktopHeader productTypes={productTypes} commercialCategories={commercialCategories} />
    </>
  );
}

export default React.memo(Header);
